import Slider from '@mui/material/Slider';

export { Slider };
